import { Button } from '@material-ui/core'
import React from 'react'

import i18n from '@flatsy/utils/translations'
import { Body1, Header1 } from '@flatsy/core/MaterialUi/Typo'
import { isPublicAssetFromLamyNetwork } from '@flatsy/utils/Functions/Assets'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import LamyPrivacyNotice from 'src/utils/Lamy'

import useStyles from './Style'

const Failure: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const { asset } = useApplicationDetails()

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.inner}>
          <Header1 align="center" className={classes.title}>
            {i18n.t('sorry')}
          </Header1>
          <Body1 className={classes.text} align="center">
            {i18n.t('unfortunately_information_provided_does_not_meet_eligibility_criteria')}
          </Body1>
          {asset && asset.ad_url && (
            <>
              <div className={classes.border} />
              <Button
                variant="contained"
                color="primary"
                disableElevation
                className={classes.buttonFailed}
                href={asset.ad_url}
              >
                {i18n.t('return_to_the_classified_ad')}
              </Button>
            </>
          )}
        </div>
        {isPublicAssetFromLamyNetwork(asset) && (
          <LamyPrivacyNotice trigger="Pour plus d’informations sur la collecte et le traitement des données" />
        )}
      </div>
    </div>
  )
}

export default Failure
